import callAPiBase from './base';

const balanceApi = {
  balanceGet: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/appUserBalance',
      method: 'POST',
      useToken: true,
      title: 'balance',
      data,
    }),
  walletDebit: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/walletDebit',
      method: 'POST',
      useToken: true,
      title: 'walletDebit',
      data,
    }),
};

export { balanceApi };
export default balanceApi;
